import { useImage } from '~/composables/useImage';

export const addImageSizeToUrl = (url: string, type: string): string => {
  const {imageSizes} = useImage();
  const imageSizeParameter = `height=${imageSizes[type].height}&width=${imageSizes[type].width}`;
  if(url.includes('?')){
    url = url + `&${imageSizeParameter}`;
  }else {
    url = url + `?${imageSizeParameter}`;
  }
  return url;
}
